import React from 'react';
import { Box, Typography } from '@mui/material';

const RegisterPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Register Page</Typography>
      <Typography variant="body1">Registration functionality will be implemented here.</Typography>
    </Box>
  );
};

export default RegisterPage; 